import type { StepForms } from '@/stores/slices/setup-fund-slice';

export const MANAGED_ACCOUNT_CATEGORY_CODE = 'MAS';

export const isManagedAccount = (forms: StepForms) =>
  forms.investmentDescription?.category === MANAGED_ACCOUNT_CATEGORY_CODE;
